(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-column-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('seriton-multi-column-slider')) return;
  class SeritonMultiColumnSlider extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        if (!this.ready) {
          this.ready = () => {this.ready=null;this.initialize();};
          document.addEventListener('DOMContentLoaded',this.ready,{once:true});
        }
      } else this.initialize();
    }
    initialize() {
      if (this.abort || !this.isConnected) return;
      this.track=this.querySelector('.multi-column-slider__track');
      if (!this.track) return;
      this.prev=this.querySelector('[data-mcs-prev]');this.next=this.querySelector('[data-mcs-next]');
      this.controls=this.querySelector('.multi-column-slider__controls');this.cards=[...this.track.querySelectorAll('[data-mcs-item]')];
      this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal:this.abort.signal});
      on(this.track,'scroll',()=>this.schedule(),{passive:true});
      on(this.prev,'click',()=>this.go(-1));on(this.next,'click',()=>this.go(1));
      on(this.track,'keydown',e=>{
        if(e.target!==this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();
        if(e.key==='Home'||e.key==='End')this.move(e.key==='Home'?0:this.maximum);
        else this.go(e.key==='ArrowRight'?1:-1);
      });
      on(this.track,'pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('video,video-media,button,input,select,textarea'))return;
        this.suppress=false;this.drag={id:e.pointerId,x:e.clientX,left:this.track.scrollLeft,moved:false};
      });
      on(this.track,'pointermove',e=>{
        if(!this.drag||this.drag.id!==e.pointerId)return;
        const dx=e.clientX-this.drag.x;if(Math.abs(dx)<5&&!this.drag.moved)return;
        if(!this.drag.moved){this.drag.moved=true;this.track.dataset.dragging='';this.track.setPointerCapture(e.pointerId);}
        e.preventDefault();this.track.scrollLeft=this.drag.left-dx;
      });
      const end=()=>{
        if(!this.drag)return;
        const id=this.drag.id;this.suppress=this.drag.moved;this.drag=null;
        if(this.track.hasPointerCapture(id))this.track.releasePointerCapture(id);
        delete this.track.dataset.dragging;
        clearTimeout(this.clickTimer);this.clickTimer=setTimeout(()=>this.suppress=false,250);this.schedule();
      };
      on(this.track,'pointerup',end);on(this.track,'pointercancel',end);on(this.track,'lostpointercapture',end);
      on(this.track,'pointerleave',()=>{if(this.drag&&!this.drag.moved)this.drag=null;});
      on(this.track,'click',e=>{if(this.suppress){e.preventDefault();e.stopImmediatePropagation();}},{capture:true});
      on(this.track,'dragstart',e=>{if(!e.target.closest('video,video-media,input,textarea'))e.preventDefault();});
      on(this,'shopify:block:select',e=>{
        const card=this.cards.find(c=>c.dataset.mcsBlockId===e.detail?.blockId||c===e.target||c.contains(e.target));
        if(card)this.track.scrollTo({left:card.offsetLeft,behavior:'auto'});
      });
      on(this.track,'load',()=>this.schedule(),{capture:true});
      if(window.ResizeObserver){this.observer=new ResizeObserver(()=>this.schedule());this.observer.observe(this.track);}
      else on(window,'resize',()=>this.schedule());
      this.update();
    }
    get maximum(){return Math.max(0,this.track.scrollWidth-this.track.clientWidth);}
    update(){const max=this.maximum,left=this.track.scrollLeft;this.controls.hidden=max<=2;this.controls.style.setProperty('--mcs-progress',this.track.scrollWidth?Math.max(0,Math.min(1,(left+this.track.clientWidth)/this.track.scrollWidth)):1);this.prev.disabled=left<=2;this.next.disabled=left>=max-2;}
    schedule(){if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.update();});}
    move(left){this.track.scrollTo({left,behavior:this.motion.matches?'auto':'smooth'});}
    go(direction){
      const x=this.track.scrollLeft;
      const offsets=this.cards.map(c=>c.offsetLeft);
      const target=direction>0?offsets.find(v=>v>x+3):offsets.reverse().find(v=>v<x-3);
      this.move(target===undefined?(direction>0?this.maximum:0):target);
    }
    disconnectedCallback(){
      if(this.ready)document.removeEventListener('DOMContentLoaded',this.ready);this.ready=null;
      this.abort?.abort();this.abort=null;this.observer?.disconnect();this.observer=null;
      cancelAnimationFrame(this.frame);this.frame=null;clearTimeout(this.clickTimer);this.drag=null;this.suppress=false;
      if(this.track)delete this.track.dataset.dragging;
    }
  }
  customElements.define('seriton-multi-column-slider',SeritonMultiColumnSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-brand-timeline"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('seriton-brand-timeline'))return;
  customElements.define('seriton-brand-timeline',class extends HTMLElement{
    connectedCallback(){queueMicrotask(()=>{
      if(!this.isConnected||this.observer||matchMedia('(prefers-reduced-motion:reduce)').matches||!('IntersectionObserver'in window))return;
      this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        try{entry.target.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:560,easing:'cubic-bezier(.2,.65,.3,1)'});}catch(e){}
        this.observer.unobserve(entry.target);
      }),{threshold:.12});this.querySelectorAll('.sbt__stage').forEach(el=>this.observer.observe(el));
    });}
    disconnectedCallback(){this.observer?.disconnect();this.observer=null;}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-community-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('seriton-community-banner'))return;
 customElements.define('seriton-community-banner',class extends HTMLElement{
  connectedCallback(){
   if(!this.querySelector('[data-scb-ready]')){this.waiter=new MutationObserver(()=>{if(this.querySelector('[data-scb-ready]')){this.waiter.disconnect();this.initialize();}});this.waiter.observe(this,{childList:true,subtree:true});return;}
   this.initialize();
  }
  initialize(){
   this.observer?.disconnect();this.visual=this.querySelector('.scb__visual');this.area=this.querySelector('.scb__positions');this.groups=[...this.querySelectorAll('[data-scb-position]')];
   this.setAttribute('data-scb-enhanced','');this.layout();
   if('ResizeObserver' in window){this.observer=new ResizeObserver(()=>this.schedule());this.observer.observe(this.area);this.groups.forEach(g=>this.observer.observe(g));}
   else{this.removeAttribute('data-scb-enhanced');this.visual.style.height='';}
   document.fonts?.ready.then(()=>{if(this.isConnected)this.schedule();});
  }
  schedule(){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{if(this.isConnected)this.layout();});}
  layout(){
   const root=getComputedStyle(this),safe=parseFloat(root.getPropertyValue('--scb-safe'))||0,base=parseFloat(root.getPropertyValue('--scb-height'))||520;
   const width=Math.max(1,this.visual.clientWidth-safe*2),height=Math.max(1,base-safe*2),placed=[];
   let bottom=0;
   this.groups.forEach(group=>{
    group.hidden=!group.textContent.trim();if(group.hidden)return;
    const style=getComputedStyle(group),w=Math.min(width,group.offsetWidth),h=group.offsetHeight,gap=parseFloat(style.getPropertyValue('--scb-gap'))||16;
    const x=Math.max(0,Math.min(100,parseFloat(style.getPropertyValue('--scb-x'))||0)),y=Math.max(0,Math.min(100,parseFloat(style.getPropertyValue('--scb-y'))||0));
    const left=Math.max(0,(width-w)*x/100);let top=Math.max(0,(height-h)*y/100);
    for(let pass=0;pass<placed.length+1;pass++){
     const hits=placed.filter(p=>left<p.right+gap&&left+w>p.left-gap&&top<p.bottom+gap&&top+h>p.top-gap);
     if(!hits.length)break;top=Math.max(...hits.map(p=>p.bottom+gap));
    }
    group.style.left=left+'px';group.style.top=top+'px';group.style.transform='none';
    placed.push({left,right:left+w,top,bottom:top+h});bottom=Math.max(bottom,top+h);
   });
   const needed=Math.max(base,Math.ceil(bottom+safe*2));if(this.visual.style.height!==needed+'px')this.visual.style.height=needed+'px';
  }
  disconnectedCallback(){this.waiter?.disconnect();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-interactive-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('seriton-linked-marquee'))return;
  customElements.define('seriton-linked-marquee',class extends HTMLElement {
    connectedCallback(){
      if(document.readyState==='loading'){
        this.ready=()=>{if(this.isConnected)this.init();};document.addEventListener('DOMContentLoaded',this.ready,{once:true});
      }else queueMicrotask(()=>{if(this.isConnected)this.init();});
    }
    init(){
      if(this.abort)return;
      this.group=this.querySelector('[data-primary]');this.track=this.querySelector('.sim__track');if(!this.group||!this.track)return;
      this.items=Array.from(this.group.children);this.abort=new AbortController();const signal=this.abort.signal;
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.motion.addEventListener('change',()=>this.build(),{signal});
      this.addEventListener('shopify:block:select',e=>{this.setAttribute('data-editing','');e.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});},{signal});
      this.addEventListener('shopify:block:deselect',()=>{this.scrollLeft=0;this.removeAttribute('data-editing');},{signal});
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.scrollLeft=0;},{signal});
      this.resize=new ResizeObserver(()=>this.schedule());this.resize.observe(this);
      this.build();document.fonts?.ready.then(()=>{if(this.isConnected&&this.abort)this.build();});
    }
    schedule(){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.build());}
    clone(node){
      const copy=node.cloneNode(true);copy.setAttribute('data-sim-clone','');copy.setAttribute('aria-hidden','true');
      [copy,...copy.querySelectorAll('*')].forEach(el=>{el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');if(el.matches('a,button,input,[tabindex]'))el.setAttribute('tabindex','-1');});
      return copy;
    }
    build(){
      this.removeAttribute('data-ready');this.querySelectorAll('[data-sim-clone]').forEach(el=>el.remove());
      if(!this.items.length||this.motion.matches||!this.clientWidth)return;
      const base=this.group.getBoundingClientRect().width;if(!base)return;
      const repeats=Math.min(200,Math.max(1,Math.ceil(this.clientWidth/base)));
      for(let n=1;n<repeats;n++)this.items.forEach(el=>this.group.append(this.clone(el)));
      const distance=this.group.getBoundingClientRect().width;
      this.track.append(this.clone(this.group));
      const speed={slow:24,medium:38,fast:56}[this.dataset.speed]||38;
      this.style.setProperty('--sim-distance',distance+'px');this.style.setProperty('--sim-duration',distance/speed+'s');this.setAttribute('data-ready','');
    }
    disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.ready);this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-technical-highlights"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('seriton-technical-highlights')) return;
  class SeritonTechnicalHighlights extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        if (!this.readyHandler) {
          this.readyHandler = () => { this.readyHandler = null; this.initialize(); };
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        }
        return;
      }
      this.initialize();
    }
    initialize() {
      if (!this.isConnected) return;
      if (this.abort) return;
      this.track = this.querySelector('.sth__track');
      if (!this.track) return;
      this.cards = [...this.track.querySelectorAll('.sth__card')];
      this.range = this.querySelector('.sth__range');
      this.controls = this.querySelector('.sth__controls');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('.sth__status');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      on(this.track, 'scroll', () => this.schedule(), { passive: true });
      on(this.prev, 'click', () => this.go(-1));
      on(this.next, 'click', () => this.go(1));
      on(this.range, 'input', () => {
        this.track.dataset.range = '';
        this.track.scrollLeft = this.maximum * Number(this.range.value) / 1000;
        this.update();
      });
      const releaseRange = () => {
        delete this.track.dataset.range;
        this.schedule();
      };
      on(this.range, 'change', releaseRange);
      on(this.range, 'blur', releaseRange);
      on(this.range, 'pointercancel', releaseRange);
      on(this.track, 'keydown', (event) => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.scrollTo(event.key === 'Home' ? 0 : this.maximum);
        else this.go(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this.track, 'pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.suppressClick = false;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
      });
      on(this.track, 'pointermove', (event) => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) < 5 && !this.drag.moved) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.dataset.dragging = '';
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      });
      const endDrag = () => {
        if (!this.drag) return;
        this.suppressClick = this.drag.moved;
        const pointerId = this.drag.id;
        this.drag = null;
        if (this.track.hasPointerCapture(pointerId)) this.track.releasePointerCapture(pointerId);
        delete this.track.dataset.dragging;
        clearTimeout(this.clickTimer);
        this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 250);
        this.schedule();
      };
      on(this.track, 'pointerup', endDrag);
      on(this.track, 'pointercancel', endDrag);
      on(this.track, 'lostpointercapture', () => { if (this.drag) endDrag(); });
      on(this.track, 'pointerleave', () => { if (this.drag && !this.drag.moved) this.drag = null; });
      on(this.track, 'click', (event) => {
        if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { capture: true });
      on(this.track, 'dragstart', (event) => event.preventDefault());
      on(this, 'shopify:block:select', (event) => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId || item === event.target || item.contains(event.target));
        if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'auto' });
      });
      on(this.track, 'load', () => this.schedule(), { capture: true });
      on(this.track, 'error', (event) => {
        if (event.target instanceof HTMLImageElement) {
          event.target.hidden = true;
          event.target.closest('.sth__card')?.setAttribute('data-no-image', '');
        }
      }, { capture: true });
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this.track);
        this.cards.forEach(card => this.resize.observe(card));
      } else on(window, 'resize', () => this.schedule());
      this.update();
    }
    get maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      const max = this.maximum;
      const left = Math.max(0, Math.min(max, this.track.scrollLeft));
      const hasNavigation = !this.range.hidden || !this.prev.parentElement.hidden;
      this.controls.hidden = max <= 2 || !hasNavigation;
      this.prev.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      this.range.disabled = max <= 2;
      this.range.value = max ? String(Math.round(left / max * 1000)) : '0';
      this.range.style.setProperty('--sth-thumb', `${Math.min(100, this.track.clientWidth / this.track.scrollWidth * 100)}%`);
      const visible = this.cards.filter(card => card.offsetLeft + card.offsetWidth > left + 3 && card.offsetLeft < left + this.track.clientWidth - 3);
      const first = visible.length ? this.cards.indexOf(visible[0]) + 1 : 1;
      const last = visible.length ? this.cards.indexOf(visible[visible.length - 1]) + 1 : first;
      const message = `Highlights ${first}–${last} of ${this.cards.length}`;
      this.range.setAttribute('aria-valuetext', message);
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => { if (this.status) this.status.textContent = message; }, 180);
      // Preserve the approved layout for ordinary copy; protect long merchant text from clipping.
      this.cards.forEach(card => {
        const copy = card.querySelector('.sth__copy');
        const ratio = getComputedStyle(card).getPropertyValue('--sth-ratio').split('/').map(Number);
        const frameHeight = card.clientWidth * (ratio[1] || 1) / (ratio[0] || 1);
        card.toggleAttribute('data-text-only', !!copy && copy.scrollHeight > frameHeight - 8);
      });
    }
    scrollTo(left) { this.track.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' }); }
    go(direction) {
      const offset = this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      this.scrollTo(this.track.scrollLeft + direction * offset);
    }
    disconnectedCallback() {
      if (this.readyHandler) document.removeEventListener('DOMContentLoaded', this.readyHandler);
      this.readyHandler = null;
      this.abort?.abort(); this.abort = null;
      this.resize?.disconnect(); this.resize = null;
      cancelAnimationFrame(this.frame); this.frame = null;
      clearTimeout(this.clickTimer); clearTimeout(this.announceTimer);
      this.drag = null; this.suppressClick = false;
      if (this.track) { delete this.track.dataset.dragging; delete this.track.dataset.range; }
    }
  }
  customElements.define('seriton-technical-highlights', SeritonTechnicalHighlights);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('seriton-ugc-gallery')) return;
 customElements.define('seriton-ugc-gallery', class extends HTMLElement {
  connectedCallback() {
   if (!this.querySelector('.sugc__status')) {
    this.waiter = new MutationObserver(() => {if (this.querySelector('.sugc__status')) {this.waiter.disconnect();this.initialize();}});
    this.waiter.observe(this,{childList:true,subtree:true});return;
   }
   this.initialize();
  }
  initialize() {
   this.controller?.abort();this.revealObserver?.disconnect();this.revealObserver=null;
   this.motionAnimations?.forEach(animation=>animation.cancel());this.motionAnimations=new Set();
   this.photoRequest=(this.photoRequest||0)+1;this.closing=false;
   this.revealed=this.revealed||new WeakSet();this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.tiles=[...this.querySelectorAll('[data-gallery-tile]')];this.button=this.querySelector('.sugc__actions button');this.label=this.querySelector('[data-sugc-label]');this.status=this.querySelector('.sugc__status');
   this.limit=Math.max(1,Number(this.dataset.initial)||6);this.batch=Math.max(0,Number(this.dataset.batch)||0);this.enabled=this.dataset.expand==='true';this.shown=this.enabled?this.limit:this.tiles.length;
   this.dialog=this.querySelector('dialog');this.large=this.querySelector('.sugc__large');this.error=this.querySelector('[data-photo-error]');this.source=this.querySelector('[data-photo-source]');this.index=0;
   this.button.addEventListener('click',()=>this.toggle(),opts);
   this.tiles.forEach(tile=>{
    const image=tile.querySelector('img'),link=tile.querySelector('[data-gallery-open]');
    link.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();this.opener=link;this.index=this.validTiles().indexOf(tile);this.showPhoto();if(!this.dialog.open){this.dialog.showModal();this.animateMotion(this.dialog,[{opacity:0,transform:'scale(.995)'},{opacity:1,transform:'scale(1)'}],240);}},opts);
    image.addEventListener('error',()=>{tile.dataset.failed='';tile.hidden=true;this.refresh();},opts);
    if(image.complete&&image.naturalWidth===0){tile.dataset.failed='';tile.hidden=true;}
   });
   this.querySelector('[data-photo-close]').addEventListener('click',()=>this.closePhoto(),opts);
   this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.closePhoto();},opts);
   this.querySelector('[data-photo-prev]').addEventListener('click',()=>this.step(-1),opts);
   this.querySelector('[data-photo-next]').addEventListener('click',()=>this.step(1),opts);
   this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.step(e.key==='ArrowLeft'?-1:1);}},opts);
   this.dialog.addEventListener('close',()=>{if(this.opener?.isConnected)this.opener.focus({preventScroll:true});},opts);
   this.large.addEventListener('load',()=>{this.large.removeAttribute('aria-busy');this.large.hidden=false;this.error.hidden=true;},opts);
   this.large.addEventListener('error',()=>{this.large.removeAttribute('aria-busy');this.large.hidden=true;this.error.hidden=false;},opts);
   const frame=this.querySelector('.sugc__lightbox-frame');
   frame.addEventListener('pointerdown',e=>{if(!e.isPrimary||e.button!==0){this.touch=null;return;}this.touch={x:e.clientX,y:e.clientY};frame.setPointerCapture(e.pointerId);},opts);
   frame.addEventListener('pointerup',e=>{if(!this.touch)return;const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)this.step(dx<0?1:-1);},opts);
   frame.addEventListener('pointercancel',()=>{this.touch=null;},opts);
   this.addEventListener('shopify:block:select',e=>{const i=this.validTiles().findIndex(t=>t===e.target||t.contains(e.target));if(i>=this.shown){this.shown=i+1;this.refresh();}},opts);
   this.refresh();this.setupReveals();
   this.motion.addEventListener('change',()=>{this.motionAnimations.forEach(animation=>animation.cancel());this.setupReveals();},opts);
  }
  disconnectedCallback(){
   this.waiter?.disconnect();this.revealObserver?.disconnect();this.motionAnimations?.forEach(animation=>animation.cancel());
   this.photoRequest=(this.photoRequest||0)+1;if(this.pendingImage){this.pendingImage.onload=null;this.pendingImage.onerror=null;}
   if(this.dialog?.open)this.dialog.close();this.controller?.abort();
  }
  animateMotion(element,frames,duration,delay=0){
   if(this.motion.matches||!element.animate)return null;
   try{const animation=element.animate(frames,{duration,delay,fill:'backwards',easing:'cubic-bezier(.2,.65,.3,1)'});this.motionAnimations.add(animation);
    animation.finished.catch(()=>{}).finally(()=>this.motionAnimations.delete(animation));return animation;
   }catch{return null;}
  }
  setupReveals(){
   this.revealObserver?.disconnect();this.revealObserver=null;
   if(this.motion.matches||!('IntersectionObserver' in window))return;
   try{this.revealObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)this.revealTile(entry.target);});},{threshold:.08});this.queueReveals(false);}
   catch{this.revealObserver?.disconnect();this.revealObserver=null;}
  }
  queueReveals(enter=false){
   if(!this.revealObserver)return;
   try{this.validTiles().forEach(tile=>{
    if(tile.hidden||this.revealed.has(tile))return;
    const rect=tile.getBoundingClientRect();
    if(rect.bottom>0&&rect.top<window.innerHeight){
     if(enter)this.revealTile(tile);else{this.revealed.add(tile);this.revealObserver.unobserve(tile);}
    }else this.revealObserver.observe(tile);
   });}catch{this.revealObserver.disconnect();this.revealObserver=null;}
  }
  revealTile(tile){
   if(tile.hidden||tile.hasAttribute('data-failed')||this.revealed.has(tile))return;
   this.revealed.add(tile);this.revealObserver?.unobserve(tile);
   if(tile.contains(document.activeElement))return;
   this.animateMotion(tile,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],560,((Number(tile.dataset.rank)||1)-1)%3*25);
  }
  closePhoto(){
   if(this.closing||!this.dialog.open)return;
   this.closing=true;const dialog=this.dialog;
   const animation=this.animateMotion(dialog,[{opacity:1,transform:'scale(1)'},{opacity:0,transform:'scale(.995)'}],220);
   const finish=()=>{if(this.isConnected&&dialog===this.dialog&&dialog.open)dialog.close();this.closing=false;};
   if(animation)animation.finished.catch(()=>{}).then(finish);else finish();
  }
  validTiles(){return this.tiles.filter(t=>!t.hasAttribute('data-failed'));}
  refresh(enter=false){
   const tiles=this.validTiles();tiles.forEach((tile,i)=>{const was=tile.hidden;tile.hidden=i>=this.shown;tile.dataset.rank=i+1;tile.toggleAttribute('data-entering',enter&&was&&!tile.hidden);});
   const more=this.enabled&&this.shown<tiles.length;this.dataset.featuredCount=Math.min(3,this.shown,tiles.length);
   this.querySelector('.sugc__actions').hidden=!this.enabled||tiles.length<=this.limit;this.label.textContent=more?'VIEW MORE':'SHOW LESS';this.button.setAttribute('aria-expanded',String(this.shown>this.limit));
   this.status.textContent=`${Math.min(this.shown,tiles.length)} of ${tiles.length} photos shown`;this.queueReveals(enter);
  }
  toggle(){
   const total=this.validTiles().length,collapse=this.shown>=total;
   this.shown=collapse?this.limit:(this.batch?Math.min(total,this.shown+this.batch):total);
   this.refresh(!collapse);
   if(collapse)this.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  step(delta){const total=this.validTiles().length;if(total<2)return;this.index=(this.index+delta+total)%total;this.showPhoto();}
  showPhoto(){
   const tiles=this.validTiles();if(!tiles.length)return;this.index=(this.index+tiles.length)%tiles.length;
   const tile=tiles[this.index],link=tile.querySelector('[data-gallery-open]'),thumbnail=tile.querySelector('img');
   const request=++this.photoRequest,url=link.href;
   if(this.pendingImage){this.pendingImage.onload=null;this.pendingImage.onerror=null;}
   this.error.hidden=true;
   const commit=()=>{
    if(!this.isConnected||request!==this.photoRequest)return;
    this.photoAnimation?.cancel();this.large.alt=thumbnail.alt;this.large.src=url;this.large.hidden=false;this.large.removeAttribute('aria-busy');
    this.photoAnimation=this.animateMotion(this.large,[{opacity:.35},{opacity:1}],220);
   };
   if(this.large.src!==url||!this.large.complete||!this.large.naturalWidth){
    if(!this.large.naturalWidth)this.large.setAttribute('aria-busy','true');
    const pending=this.pendingImage=new Image();
    pending.onload=()=>{if(pending.decode)pending.decode().catch(()=>{}).then(commit);else commit();};
    pending.onerror=()=>{if(this.isConnected&&request===this.photoRequest){this.large.removeAttribute('aria-busy');this.large.hidden=true;this.error.hidden=false;}};
    pending.src=url;
   }else{this.large.hidden=false;this.large.removeAttribute('aria-busy');}
   this.querySelector('[data-photo-counter]').textContent=`${this.index+1} / ${tiles.length}`;
   this.querySelector('[data-photo-prev]').hidden=tiles.length<2;this.querySelector('[data-photo-next]').hidden=tiles.length<2;
   const sourceUrl=link.dataset.sourceLink;this.source.hidden=!sourceUrl;if(sourceUrl)this.source.href=sourceUrl;else this.source.removeAttribute('href');
  }
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seriton-youtube-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('seriton-youtube-reviews')) return;
  class SeritonYouTubeReviews extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        this.ready = () => { if (this.isConnected) this.init(); };
        document.addEventListener('DOMContentLoaded', this.ready, {once:true});
      } else queueMicrotask(() => { if (this.isConnected) this.init(); });
    }
    init() {
      if (this.abort) return;
      this.track = this.querySelector('.syr__track');
      this.dialog = this.querySelector('dialog');
      if (!this.track || !this.dialog) return;
      this.abort = new AbortController();const signal = this.abort.signal;
      this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.range=this.querySelector('input[type="range"]');
      this.onUpdate=()=>this.update();
      this.track.addEventListener('scroll',this.onUpdate,{passive:true,signal});
      this.prev.addEventListener('click',()=>this.move(-1),{signal});
      this.next.addEventListener('click',()=>this.move(1),{signal});
      this.range.addEventListener('input',()=>this.seek(Number(this.range.value)/1000*this.max(),false),{signal});
      this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();this.seek(e.key==='Home'?0:this.max(),true);}},{signal});
      this.track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0)return;
        this.suppressClick=false;this.drag={id:e.pointerId,start:e.clientX,left:this.track.scrollLeft,moved:false};
      },{signal});
      this.track.addEventListener('pointermove',e=>{
        const d=this.drag;if(!d||d.id!==e.pointerId)return;
        const dx=e.clientX-d.start;if(!d.moved&&Math.abs(dx)<6)return;
        if(!d.moved){d.moved=true;this.track.setPointerCapture(e.pointerId);this.track.setAttribute('data-dragging','');}
        this.track.scrollLeft=d.left-dx;
      },{signal});
      const finish=()=>{if(!this.drag)return;this.suppressClick=this.drag.moved;this.drag=null;this.track.removeAttribute('data-dragging');};
      this.track.addEventListener('pointerup',finish,{signal});this.track.addEventListener('pointercancel',finish,{signal});
      this.track.addEventListener('pointerleave',()=>{if(this.drag&&!this.drag.moved)this.drag=null;},{signal});
      this.track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
      this.track.addEventListener('click',e=>{
        if(this.suppressClick && e.detail!==0){e.preventDefault();e.stopPropagation();this.suppressClick=false;return;}
        const card=e.target.closest('[data-review]');if(card)this.open(card);
      },{capture:true,signal});
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),{signal});
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();},{signal});
      this.dialog.addEventListener('close',()=>this.clearPlayer(),{signal});
      this.track.addEventListener('error',e=>{if(e.target.tagName==='IMG')e.target.style.visibility='hidden';},{capture:true,signal});
      this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-review]');if(card)card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});},{signal});
      this.observer=new ResizeObserver(this.onUpdate);this.observer.observe(this.track);this.update();
    }
    max(){return Math.max(0,this.track.scrollWidth-this.track.clientWidth);}
    position(){return Math.abs(this.track.scrollLeft);}
    seek(value,smooth){this.track.scrollTo({left:(getComputedStyle(this.track).direction==='rtl'?-1:1)*Math.max(0,Math.min(this.max(),value)),behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'auto'});}
    move(direction){const card=this.track.querySelector('[data-review]');if(card)this.seek(this.position()+direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap||0)),true);}
    update(){const max=this.max(),p=this.position();this.querySelector('[data-controls]').hidden=max<2||(this.range.hidden&&this.querySelector('.syr__arrows').hidden);this.prev.disabled=p<=3;this.next.disabled=p>=max-3;this.range.value=max?Math.round(p/max*1000):0;this.range.style.setProperty('--syr-thumb',Math.min(100,this.track.clientWidth/Math.max(1,this.track.scrollWidth)*100)+'%');}
    open(card){
      const id=card.dataset.videoId;if(!/^[A-Za-z0-9_-]{11}$/.test(id))return;
      this.clearPlayer();this.querySelector('[data-player-title]').textContent=card.dataset.videoTitle;
      this.querySelector('[data-watch]').href='https://www.youtube.com/watch?v='+id;
      const frame=document.createElement('iframe');frame.title=card.dataset.videoTitle;frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
      frame.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';
      this.querySelector('[data-player]').append(frame);this.dialog.showModal();
    }
    clearPlayer(){this.querySelector('[data-player]')?.replaceChildren();}
    disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.ready);if(this.dialog?.open)this.dialog.close();this.clearPlayer();this.abort?.abort();this.abort=null;this.observer?.disconnect();this.drag=null;}
  }
  customElements.define('seriton-youtube-reviews',SeritonYouTubeReviews);
})();

  } catch(e) { console.error(e); }
})();
})();
